import { environment } from 'src/environments/environment';
import { replaceEdpointParams } from 'src/app/helpers/endpoints-helpers';

/**
 * Monta a URL absoluta de um endpoint admin, substituindo os placeholders
 * `$param$` e concatenando com `environment.apiUrl` (vazio em local → relativo
 * via proxy). Normaliza barras duplicadas na junção base/context.
 */
export function adminUrl(endpoint: string, params?: Record<string, string | number>): string {
  const stringParams: Record<string, string> = {};
  if (params) {
    for (const [k, v] of Object.entries(params)) stringParams[k] = String(v);
  }
  const context = replaceEdpointParams(endpoint, stringParams);
  const base = environment.apiUrl ?? '';
  if (!base) return context.startsWith('/') ? context : `/${context}`;
  return `${base.replace(/\/+$/, '')}/${context.replace(/^\/+/, '')}`;
}
